export const STOREFRONT_LANGUAGE_PREFERENCE_STORAGE_KEY = 'storefrontPreferredLanguage'

export type StorefrontLanguage = 'pt-BR' | 'es' | 'en'

export function normalizeStorefrontLanguage(value: unknown): StorefrontLanguage | null {
  if (typeof value !== 'string') return null

  const normalized = value.trim().toLowerCase()
  if (normalized === 'pt' || normalized.startsWith('pt-')) return 'pt-BR'
  if (normalized === 'es' || normalized.startsWith('es-')) return 'es'
  if (normalized === 'en' || normalized.startsWith('en-')) return 'en'

  return null
}

export function readStorefrontLanguagePreference(): StorefrontLanguage | null {
  try {
    return normalizeStorefrontLanguage(
      globalThis.localStorage?.getItem(STOREFRONT_LANGUAGE_PREFERENCE_STORAGE_KEY),
    )
  } catch {
    return null
  }
}

export function saveStorefrontLanguagePreference(language: StorefrontLanguage): void {
  try {
    globalThis.localStorage?.setItem(STOREFRONT_LANGUAGE_PREFERENCE_STORAGE_KEY, language)
  } catch {
    // O idioma ainda muda na sessão atual quando o navegador bloqueia o storage.
  }
}

export function resolveStorefrontLanguage(
  automaticLanguage: StorefrontLanguage,
): StorefrontLanguage {
  return readStorefrontLanguagePreference() ?? automaticLanguage
}
